import React, { Component } from 'react';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import url from '../../media/about_us.jpg';

const AboutUsImage = injectIntl(({alt, intl}) => (
	<img src={url} alt={intl.formatMessage({id:alt})} />
));

class AboutUsPage extends Component{
	render(){
		const {page} = this.props;
		return (
			<div className="container-flex">
				<div className="page__banner page__banner--camera">
					<h2>
						<FormattedMessage id={'page.title.' + page.title.toLowerCase().replace(' ','-')} />
					</h2>
				</div>
				<div className="page">
					<div className={page.contentClass}>
                        <h3>
							<FormattedMessage id={'amiko.page.about-us.title'}/>
						</h3>
						<FormattedHTMLMessage id={'amiko.page.about-us.content-before-image'}/>
						<AboutUsImage alt={'amiko.page.about-us.title'}/>
                        <FormattedHTMLMessage id={'amiko.page.about-us.content'}/>
					</div>
				</div>
			</div>
		);
	}
}

export default AboutUsPage;


// WEBPACK FOOTER //
// ./src/components/page/AboutUsPage.js